<div class="container">

  <app-curriculum [(show)]="showContact"
               [ngStyle]="{'display': firstLoad? 'none' : 'unset'}"
               [ngClass]="{'show-contact': showContact, 'hide-contact': !showContact && !firstLoad}">
  </app-curriculum>
  <button vertical="true"
          [ngClass]="{'hide-button': showContact, 'show-button': !showContact && !firstLoad }"
          (click)="hideOrShowContact()">
    <p>CURRÍCULO</p>
  </button>
  <!--              [ngStyle]="{display: showContact? 'none' : 'unset'}"-->


</div>
